import {reactive, watch, computed, inject} from "vue";

import { getDataAsync, patchDataAsync, postDataAsync, deleteDataAsync } from "helpers/_api";
import { apiHostname } from "config";
import { getUrlWithQueryDataAdded } from "helpers/_structure";
import { userStore } from "store/user-store";

const actionFilterMapping = {
	"overview": [
		[
			"FieldFilter",
			{
				"column": "state",
				"value": "Online"
			}
		]
	],
	"related": [],
	"draft": [
		[
			"FieldFilter",
			{
				"column": "state",
				"value": "Draft"
			}
		]
	],
	"important": [
		[
			"FieldFilter",
			{
				"column": "state",
				"value": "Online"
			}
		],
		[
			"FieldFilter",
			{
				"column": "important",
				"value": "Y"
			}
		]
	],
	"favorite": [
		[
			"FieldFilter",
			{
				"column": "state",
				"value": "Online"
			}
		],
		[
			"InboxfavoriteFilter",
			{
				"column": "",
				"value": "",
				"operator": "="
			}
		]
	],
	"sent": [
		[
			"FieldFilter",
			{
				"column": "state",
				"value": "Online"
			}
		],
		[
			"FieldFilter",
			{
				"column": "item_id",
				"value": "",
				"operator": "<>"
			}
		],
		[
			"FieldFilter",
			{
				"column": "module_object",
				"value": "Workflowcard",
				"operator": "="
			}
		]
	],
	"trash": [
		[
			"FieldFilter",
			{
				"column": "state",
				"value": "Offline"
			}
		]
	],
	"archive": [
		[
			"FieldFilter",
			{
				"column": "state",
				"value": "Archive"
			}
		]
	]
};

export const inboxStore = reactive({
	loading: true,
	selected: [],
	lastcheck_date: null,
	page: 1,
	total: 0,
	current: {},
	items: [],
	routeData: null,
	cached_overview: {},
	cached_item: {}

});


const resolveFilters = (routeData, extra_filters = []) => {

	return new Promise((resolve) => {

		const filters = [
			...actionFilterMapping[routeData.action],
			...extra_filters
		];

		if (routeData.search) {
			let searchableColumns = [];
			if (routeData.action === "sent") {
				searchableColumns = ["subject","to"];
			} else {
				searchableColumns = ["subject","sender_uid","sender_name"];
			}

			filters.push([
				"SecureSearchFilter",
				{
					"column": searchableColumns,
					"value": routeData.search
				}
			]);
		}
		// Disabled since we only have 'related' within portal at the moment
		// if (routeData.action !== "related") {
		// 	filters.push([
		// 		!routeData.coupled ? "HasNotRelatedFilter" : "HasRelatedFilter",
		// 		{
		// 			"c": "Inbox",
		// 			"v": "Workflowcard",
		// 		}
		// 	]);
		// }
		if ((routeData.action === "related")
			&& routeData.module_object
			&& routeData.module_item_id) {
			filters.push([
				"RelatedFilter",
				{
					"linked_ids": [routeData.module_item_id],
					"match_all": false,
					"module": routeData.module_object,
					"module_link": "Inbox"
				}
			]);
		}

		// KEEP FOR LATER USE !! CAN BE HELPFUL
		// KEEP FOR LATER USE !! CAN BE HELPFUL
		// KEEP FOR LATER USE !! CAN BE HELPFUL
		// let userWatcher;
		// userWatcher = watch(
		// 	() => userStore.current,
		// 	() => {
		// 		if (!userStore.current?.id) return;
		//
		// 		if (["sent"].includes(routeData.action)) {
		// 			filters.push([
		// 				"FieldFilter",
		// 				{
		// 					"column": "sender_uid",
		// 					"value": userStore.current.email,
		// 					"operator": "="
		// 				}
		// 			]);
		// 		}
		// 		resolve(filters);
		//
		// 		userWatcher && userWatcher();
		// 	},
		// 	{
		// 		immediate: true,
		// 		deep: true
		// 	}
		// );
		// KEEP FOR LATER USE !! CAN BE HELPFUL
		// KEEP FOR LATER USE !! CAN BE HELPFUL
		// KEEP FOR LATER USE !! CAN BE HELPFUL
		resolve(filters);
	});
};

export const resetInbox = () => {
	inboxStore.selected = [];
	inboxStore.loading = true;
	inboxStore.items = [];
	inboxStore.page = 1;
	inboxStore.total = 0;
	inboxStore.lastcheck_date = null;
};

export const clearInboxCache = (routeData) => {
	const tmpAction = `${routeData.action}`;
	const tmpInboxId = `${routeData.inbox_id}`;
	const tmpItemId = `${routeData.item_id}`;
	if (inboxStore.cached_overview[tmpAction]?.[tmpInboxId]?.[`${routeData.page}`]) {
		delete inboxStore.cached_overview[tmpAction][tmpInboxId][`${routeData.page}`];
	}
	if (tmpItemId && inboxStore.cached_item[tmpItemId]) {
		delete inboxStore.cached_item[tmpItemId]; // Delete item cache
	}
};

const resolveApiUrl = (routeData, append_query = true) => {
	let url = `${apiHostname}/api/v1.0/inbox`;
	if (routeData.action === "sent" || (routeData.action === "related" && routeData.item_type === "sent")) {
		url = `${apiHostname}/api/v1.0/emailsent`;
	}
	// Append our URL with query data
	if (append_query) {
		url = getUrlWithQueryDataAdded({limit: routeData.limit, page: routeData.page}, url);
	}
	return url;
};

export const getInboxItem = (routeData, show_loader = true) => {
	return new Promise((resolve, reject) => {
		show_loader && (inboxStore.loading = true);

		if (inboxStore.cached_item[`${routeData.item_id}`]) {
			inboxStore.loading = false;
			inboxStore.current = inboxStore.cached_item[`${routeData.item_id}`];
			resolve(inboxStore.current);
		}

		// Always get to make sure everything is freshly loaded
		getDataAsync(`${resolveApiUrl(routeData, false)}/${routeData.item_id}`).then((json) => {
			inboxStore.loading = false;
			if (JSON.stringify(json) !== JSON.stringify(inboxStore.current)) {
				inboxStore.current = json;
				inboxStore.cached_item[`${json.data.id}`] = json;
				if (`${json.data.id}` === `${routeData.item_id}`) {
					// Making sure the selected item is still set
					inboxStore.selected = [`${routeData.item_id}`];
				}
				resolve(inboxStore.current);
			}
		});
	});
};
let ticker = 0;
export const getInbox = (routeData, extra_filters = [], show_loader = true) => {
	return new Promise((resolve) => {
		// Make sure to tick
		ticker++;
		const currentTicker = ticker;

		if (routeData.item_id) {
			return getInboxItem(routeData, show_loader).then(resolve);
		}

		show_loader && (inboxStore.loading = true);

		// Set constants to work with
		const tmpInboxId = `${routeData.inbox_id}`;
		const tmpAction = `${routeData.action}`;

		if (!routeData.search && inboxStore.cached_overview[tmpAction]?.[tmpInboxId]?.[`${routeData.page}`]) {
			// Just resolve but go on by getting the fresh data
			resolve(inboxStore.cached_overview[tmpAction][tmpInboxId][`${routeData.page}`].items);
		}

		// console.log("routeData", routeData);
		resolveFilters(routeData, extra_filters).then(filters => {
			// console.log("filters", filters);
			getDataAsync(resolveApiUrl(routeData), filters).then((json) => {

				if (currentTicker !== ticker) {
					// Do nothing with the data since it is a different call
					return;
				}

				inboxStore.loading = false;
				inboxStore.lastcheck_date = json._meta.timestamp;
				inboxStore.page = json._meta.page;
				inboxStore.total = json._meta.total;
				inboxStore.items = json.data;
				inboxStore.routeData = JSON.parse(JSON.stringify(routeData));

				if (!(tmpAction in inboxStore.cached_overview)) {
					inboxStore.cached_overview[tmpAction] = {};
				}
				if (!(tmpInboxId in inboxStore.cached_overview[tmpAction])) {
					inboxStore.cached_overview[tmpAction][tmpInboxId] = {};
				}
				if (!routeData.search) {
					inboxStore.cached_overview[tmpAction][tmpInboxId][`${json._meta.page}`] = {
						lastcheck_date: json._meta.timestamp,
						total: json._meta.total,
						items: json.data
					};
				}
				resolve(inboxStore.items);
			}).catch((error) => {
				// Check if the error response is 403
				if (error.status === 403) {
					inboxStore.selected = [];
					inboxStore.loading = false;
					inboxStore.items = [];
					inboxStore.page = 1;
					inboxStore.total = 0;
					inboxStore.lastcheck_date = Date.now();
					resolve(inboxStore.items);
					return;
				}
				throw error;
			});
		});
	});
};

export const counterStore = reactive({});
export const getCount = (routeData, extra_filters = []) => {
	return new Promise((resolve) => {
		// console.log("routeData", routeData);
		if (!(routeData.action in counterStore)) {
			counterStore[routeData.action] = {
				update_key: 0,
				data: {}
			};
		}
		resolveFilters(routeData, extra_filters).then(filters => {
			// For favorite and important show all item as count
			filters.push([
				"InboxreadFilter",
				{
					"column": "",
					"value": "",
					"operator": "<>"
				}
			]);
			// No need to change the URL since emailsent won't work with InboxreadFilter anyway.
			// Sent items normally are messages which you know of, no need to get count. We skip.
			getDataAsync(`${apiHostname}/api/v1.0/inbox?limit=1`, filters).then((json) => {
				counterStore[routeData.action].data = json;
				resolve(counterStore[routeData.action].data);
			});
		});
		watch(
			() => counterStore[routeData.action].update_key,
			() => {
				getCount(routeData, extra_filters).then(json => {
					counterStore[routeData.action].data = json;
				});
			}
		);
	});
};
export const updateCount = (routeData) => {
	counterStore[routeData.action].update_key += 1;
};
export const updateAllCount = () => {
	for (const key in counterStore) {
		counterStore[key].update_key += 1;
	}
};

export const patchInbox = (inbox_id, data) => {
	return new Promise((resolve) => {
		patchDataAsync(`${apiHostname}/api/v1.0/inbox/${inbox_id}`, data).then((json) => {
			resolve(json);
		});
	});
};
export const favoriteInbox = (item_id) => {
	return new Promise((resolve) => {
		postDataAsync(`${apiHostname}/api/v1.0/inbox/${item_id}/favorite`).then((json) => {
			resolve(json);
		});
	});
};
export const readInbox = (item_id) => {
	return new Promise((resolve) => {
		postDataAsync(`${apiHostname}/api/v1.0/inbox/${item_id}/read`).then((json) => {
			resolve(json);
		});
	});
};
export const unlinkInbox = (item_id, module_object, link_id) => {
	return new Promise((resolve, reject) => {
		const targetObject = module_object.replace("Entity", "");
		getDataAsync(`${apiHostname}/api/v1.0/inbox/${item_id}/links`, [
			[
				"FieldFilter",
				{
					"column": "module_object",
					"value": targetObject,
					"operator": "="
				}
			]
		]).then((json) => {
			const targetLink = json.data.find(a => `${a.data.id}` === `${link_id}`);
			if (!targetLink) {
				return reject();
			}
			deleteDataAsync(`${apiHostname}/api/v1.0/inbox/${item_id}/links/${targetLink._meta.moduleItemLinkId}`).then(resolve).catch(reject);
		});
	});
};

export const getInboxAttachments = (inbox_id) => {
	return new Promise((resolve) => {
		getDataAsync(`${apiHostname}/api/v1.0/inbox/${inbox_id}/attachments`, [
			[
				"FieldFilter",
				{
					"column": "disposition",
					"value": "attachment",
					"operator": "="
				}
			]
		]).then((json) => {
			resolve(json);
		}).catch(() => {
// Do nothing
		});
	});
};